# Used in Calculations
# In some specific cases, a placeholder needs to be prefilled and actually editable (not only ghost mode), but remain
# as null when not in use. Example: "+41 " as placeholder, which allows persons to complete the number with "79 ..."

init = ->
  $('[data-behaviour="hard-placeholder"]').each ->
    $this = $ this
    $this.val $this.data('value') if $this.val() == ''
    $this.closest('form').on 'submit', ->
      $this.val('') if $this.val() == $this.data('value')


$(document).ready(init)
